export const articleData: Record<number, {
  id: number;
  title: string;
  summary: string;
  image: string;
  date: string;
  views: number;
  category: string;
  tags: string[];
  content: string[];
  relatedArticles: number[];
}> = {
  1: {
    id: 1,
    title: '某千万粉丝网红被曝私下辱骂粉丝，聊天记录流出引众怒',
    summary: '一段疑似某知名网红与助理的聊天记录近日在网络上疯传，内容涉及对粉丝群体的不当言论，引发大量网友声讨。',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20smartphone%20displaying%20controversial%20chat%20messages%20with%20red%20highlights%20on%20dark%20background%2C%20cinematic%20lighting%20with%20tense%20atmosphere%2C%20editorial%20photography%20style%2C%20warm%20coral%20and%20deep%20shadow%20tones&width=1200&height=600&seq=article-01-hero&orientation=landscape',
    date: '2026-07-06',
    views: 128000,
    category: '网红爆料',
    tags: ['网红', '聊天记录', '塌房', '粉丝'],
    content: [
      '近日，一段疑似某拥有千万粉丝的知名网红与助理的微信聊天记录在社交平台上广泛传播，引发轩然大波。',
      '根据流出的聊天截图显示，该网红在与助理的对话中多次使用不当词语描述自己的粉丝群体，甚至称部分铁粉为"韭菜"和"提款机"，言论之粗鄙令人咋舌。',
      '聊天记录中还显示，该网红对于粉丝送来的礼物表现出明显的不屑态度，称"反正不用白不用，他们愿意送就送呗"。这些言论被曝光后，迅速在各大社交平台引发热议。',
      '截至目前，已有超过十万粉丝在社交平台表达失望和愤怒，话题"网红辱骂粉丝"一度登上热搜榜首位。不少老粉丝表示"脱粉"并删除相关应援内容。',
      '该网红目前尚未对此事作出公开回应，其工作室电话一直无人接听。据业内人士分析，此次事件可能对该网红的商业价值造成重大打击，多个品牌方已暂停与其的合作洽谈。',
      '有法律界人士表示，如果聊天记录属实，虽然不涉及法律责任，但该网红的行为已经严重违反了基本的职业道德和公序良俗。在当今粉丝经济时代，尊重粉丝是每个公众人物最基本的素养。',
    ],
    relatedArticles: [2, 5],
  },
  2: {
    id: 2,
    title: '某女星深夜密会神秘男子，酒店共度8小时被拍实锤',
    summary: '狗仔队近日蹲守某高档酒店，拍到知名女星与一神秘男子前后进入酒店，直至次日清晨才离开，引发恋情猜测。',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20hotel%20exterior%20at%20night%20with%20dramatic%20paparazzi%20style%20photography%2C%20warm%20golden%20lobby%20light%20spilling%20onto%20sidewalk%2C%20mysterious%20figure%20entering%20through%20revolving%20door&width=1200&height=600&seq=article-02-hero&orientation=landscape',
    date: '2026-07-06',
    views: 256000,
    category: '明星八卦',
    tags: ['明星', '恋情', '实锤', '酒店'],
    content: [
      '知名狗仔团队近日在某高档酒店门口蹲守多日，终于拍到了重磅画面——某当红女星深夜与一名神秘男子先后进入酒店。',
      '据狗仔透露，当晚约11点30分，该女星乘坐一辆黑色商务车抵达酒店地下车库，随后在助理陪同下进入酒店大堂。大约20分钟后，一名身材高大的男子也出现在酒店大堂，两人在电梯口短暂交流后一同上楼。',
      '令人震惊的是，直到第二天早上7点40分左右，该女星才从酒店离开，而该男子则在8点15分左右独自走出酒店。两人在酒店内共度约8小时。',
      '照片曝光后，网友迅速展开"人肉搜索"，目前已有多名网友指认该男子疑似某知名企业家的儿子。如果爆料属实，这将是一段典型的"明星+豪门"组合。',
      '该女星的经纪公司对此事保持沉默，仅表示"艺人私事不便回应"。但粉丝群体已经炸开了锅，有人祝福有人质疑，争论不休。',
    ],
    relatedArticles: [1, 5],
  },
  5: {
    id: 5,
    title: '网红情侣突然官宣分手，男方被扒出轨多名女粉丝',
    summary: '一直以恩爱示人的某网红情侣今日同时发布分手声明，随后网友扒出男方多段暧昧聊天记录，真相令人大跌眼镜。',
    image: 'https://readdy.ai/api/search-image?query=Broken%20heart%20concept%20with%20cracked%20smartphone%20screen%20showing%20breakup%20announcement%20on%20social%20media%2C%20dramatic%20sidebar%20lighting%2C%20emotional%20atmosphere%20in%20coral%20tones&width=1200&height=600&seq=article-05-hero&orientation=landscape',
    date: '2026-07-04',
    views: 445000,
    category: '网红爆料',
    tags: ['网红', '分手', '出轨', '粉丝'],
    content: [
      '今日下午，某对在社交平台拥有极高人气的网红情侣同时发布分手声明，宣布结束长达三年的恋情。然而，事情远没有那么简单。',
      '女方在声明中写道"感谢这三年，各自安好"，语气平静但略显伤感。男方则以"性格不合"为由解释分手原因。起初网友以为这只是一次普通的和平分手，但很快事情就出现了反转。',
      '分手消息传出不到两小时，就有多名自称是该男网红粉丝的女性网友开始在评论区发声，晒出了与该男网红的私下聊天记录。这些聊天内容暧昧至极，时间跨度覆盖了其与女友交往的整个期间。',
      '更令人震惊的是，有网友整理出时间线后发现，男方在与正牌女友交往期间，至少同时与5名女粉丝保持暧昧关系。其中一位女粉丝甚至表示男方曾承诺会与女友分手后和她在一起。',
      '目前该男网红的社交账号评论区已经沦陷，大批网友涌入指责其"渣男"行为。其商业合作也受到影响，已有三家品牌方宣布解除合约。',
      '这起事件再次引发了人们对网红圈恋爱诚信问题的讨论。有评论人士指出，在流量和利益的诱惑下，一些网红已经丧失了基本的道德底线。',
    ],
    relatedArticles: [1, 2],
  },
  3: {
    id: 3,
    title: '知名主播直播带货翻车，假货风波持续发酵品牌方紧急回应',
    summary: '某平台头部主播近日被消费者举报售卖假冒化妆品，直播间当场被网友截图取证，多个品牌方紧急发布声明。',
    image: 'https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20setup%20with%20dramatic%20red%20and%20warning%20sign%20overlay%2C%20product%20display%20with%20question%20marks%2C%20broadcasting%20equipment%20in%20warm%20studio%20lighting%2C%20tense%20atmosphere%2C%20editorial%20style&width=1200&height=600&seq=article-03-hero&orientation=landscape',
    date: '2026-07-05',
    views: 189000,
    category: '吃瓜大赛',
    tags: ['直播', '假货', '翻车', '消费者'],
    content: [
      '近日，某平台头部带货主播被多名消费者联合举报，指控其在直播间售卖假冒品牌化妆品。消费者晒出的对比图显示，所购产品与正品在包装、质地、气味等方面存在明显差异。',
      '随着事件的持续发酵，越来越多的消费者站出来发声。据不完全统计，已经有超过500名消费者组建维权群，涉及的订单金额超过200万元。',
      '面对舆论压力，该主播在最新一场直播中回应称"所有产品均来自正规渠道"，但拒绝提供进货凭证。品牌方则紧急发布声明，表示从未授权该主播销售旗下产品。',
      '平台官方也介入调查，表示如果查实售假行为，将对该主播进行永久封禁处理。目前直播间已被暂时关闭，等待调查结果。',
      '业内人士分析，此事件暴露出直播带货行业的监管漏洞。在巨大流量和利润的驱使下，一些主播为了追求更高佣金，不惜铤而走险售卖假冒伪劣产品。',
    ],
    relatedArticles: [1, 5],
  },
  4: {
    id: 4,
    title: '某综艺节目后台冲突曝光，两位嘉宾录制现场大打出手',
    summary: '据现场工作人员爆料，某热门综艺录制过程中两位嘉宾因游戏环节发生激烈争执，最终演变为肢体冲突。',
    image: 'https://readdy.ai/api/search-image?query=TV%20show%20studio%20backstage%20dramatic%20moment%20with%20tension%20between%20two%20silhouettes%2C%20warm%20spotlight%20and%20deep%20shadows%2C%20behind%20the%20scenes%20atmosphere%2C%20cinematic%20lighting%20with%20dramatic%20mood&width=1200&height=600&seq=article-04-hero&orientation=landscape',
    date: '2026-07-05',
    views: 312000,
    category: '明星八卦',
    tags: ['综艺', '冲突', '后台', '嘉宾'],
    content: [
      '据某热门综艺节目现场工作人员匿名爆料，在最新一期节目录制过程中，两位嘉宾因游戏环节的规则争议发生了激烈口角，继而演变为肢体冲突。',
      '爆料人称，冲突起因是一个游戏环节中关于胜负的判定。一方认为对方作弊，另一方则坚称自己完全遵守规则。双方从争论升级为推搡，现场工作人员紧急介入才将两人分开。',
      '冲突发生后，节目录制被迫中断约两小时。节目组紧急召开了协调会议，最终决定将冲突环节的镜头全部删除，并重新录制了替换内容。',
      '消息曝光后，网友迅速锁定了涉事节目和嘉宾身份。两位当事人的社交账号评论区瞬间涌入大量吃瓜群众，双方粉丝也开始互撕。',
      '目前两位嘉宾均未对事件作出公开回应，但据说节目组已经在考虑是否继续邀请其中一位参与后续录制。',
    ],
    relatedArticles: [2, 1],
  },
  6: {
    id: 6,
    title: '某顶流男团成员被曝校园霸凌黑历史，昔日同学集体发声',
    summary: '随着该男团人气飙升，多名自称是其昔日同学的网友在社交平台联合爆料其校园时期的霸凌行为，引发巨大争议。',
    image: 'https://readdy.ai/api/search-image?query=Yearbook%20style%20photo%20with%20mysterious%20redacted%20faces%20and%20dramatic%20lighting%2C%20nostalgic%20school%20corridor%20background%2C%20warm%20amber%20tones%20with%20deep%20shadows%2C%20investigative%20journalism%20aesthetic&width=1200&height=600&seq=article-06-hero&orientation=landscape',
    date: '2026-07-04',
    views: 378000,
    category: '明星八卦',
    tags: ['男团', '校园', '黑历史', '霸凌'],
    content: [
      '随着某偶像男团人气持续飙升，其成员的黑历史也开始被网友深挖。近日，多名自称是该成员昔日同学的网友在社交平台联合发声，指控其在校园期间存在严重的霸凌行为。',
      '据其中一位爆料者称，该成员在校期间经常伙同三五好友对同班一名性格内向的男生进行言语羞辱和排挤，甚至有过肢体冲突。另一位自称受害者的人士发声表示，那段经历给自己留下了深重的心理阴影。',
      '消息一出，该成员的粉丝后援会迅速发布声明，称这些指控是"恶意造谣"和"蓄意抹黑"。但随后又有更多自称是同一学校同一届的学生站出来证实了相关说法。',
      '面对日益增长的舆论压力，该成员的经纪公司发表声明称"正在核实相关情况，暂时不便评论"。但声明中并未直接否认霸凌指控，引发网友更大质疑。',
      '此事件在韩国娱乐圈也引发震动，因为类似案例在韩国已导致多位艺人事业受损。舆论普遍认为，如果指控属实，该成员的演艺生涯将面临严重危机。',
    ],
    relatedArticles: [4, 2],
  },
};

export const articleComments = [
  {
    id: 1,
    name: '吃瓜不嫌事大',
    handle: '@chigua_dalao',
    avatar: 'C',
    comment: '这瓜保熟吗？我看聊天记录那个时间线根本对不上，感觉是有人在故意搞事情。不过这个网红平时就很高调，得罪人也是迟早的事。坐等更多实锤！',
    likes: 3420,
    time: '2小时前',
  },
  {
    id: 2,
    name: '娱乐圈观察员',
    handle: '@yule_observer',
    avatar: 'Y',
    comment: '终于有人爆出来了！我在这个圈子混了五年，早就听说过这位的一些事情，只是一直没人敢说。这次应该是得罪了不该得罪的人，被人家搞了。',
    likes: 2891,
    time: '3小时前',
  },
  {
    id: 3,
    name: '理性吃瓜人',
    handle: '@lixing_chi',
    avatar: 'L',
    comment: '建议大家冷静一下，目前只有聊天截图，没有其他实锤。如果真的有问题，相信会有更多证据浮出水面。不要急着站队，让子弹再飞一会儿。',
    likes: 1567,
    time: '3小时前',
  },
  {
    id: 4,
    name: '深夜吃瓜群众',
    handle: '@shenye_gua',
    avatar: 'S',
    comment: '我艹这个瓜我吃了三天了！每天都有新进展，比追剧还精彩。那个助理反转又反转的，我已经不知道该信谁了。但不管怎样，骂粉丝确实太low了。',
    likes: 4230,
    time: '5小时前',
  },
  {
    id: 5,
    name: '八卦小能手',
    handle: '@bagua_master',
    avatar: 'B',
    comment: '作为一个专业吃瓜十年的老饕，我可以负责任地说，这个瓜的质量属于上乘。时间线清晰，人物关系完整，还有第三方佐证。五星好评！期待后续发展。',
    likes: 5102,
    time: '6小时前',
  },
  {
    id: 6,
    name: '真相挖掘机',
    handle: '@zhenxiang_jueji',
    avatar: 'Z',
    comment: '给大家补充一个冷知识：这位网红去年就和那家公司解约了，据说就是因为类似的问题。老粉应该还记得当时她突然停播了一个月吧？细思极恐。',
    likes: 3876,
    time: '7小时前',
  },
];